/**
 * Brand Configuration
 * Company branding, contact information, and social media links
 * Last Updated: March 8, 2026
 */

import { BrandSettings, ContactSettings, SocialMediaSettings } from '../types/brand-settings';

export const brandSettings: BrandSettings = {
  logo: null, // Will use default logo if null
  companyName: 'Something Property',
  tagline: 'A Step Closer To Home',
  primaryColor: '#eab308', // yellow-500
  secondaryColor: '#1e40af', // blue-800
  accentColor: '#dc2626', // red-600
};

export const contactSettings: ContactSettings = {
  phone: '+27 (011) 862-1790',
  email: 'admin@somethingproperty.co.za',
  address: '18 Drakensberg Road',
  city: 'Germiston',
  postalCode: '1424',
  country: 'South Africa',
};

export const socialMediaSettings: SocialMediaSettings = {
  facebook: 'https://facebook.com/somethingproperty',
  twitter: 'https://twitter.com/somethingprop',
  instagram: 'https://instagram.com/somethingproperty',
  linkedin: 'https://linkedin.com/company/something-property',
  youtube: 'https://youtube.com/somethingproperty',
  tiktok: 'https://tiktok.com/@somethingproperty',
  whatsapp: '+27615483584',
};
